module.exports = __webpack_public_path__ + "static/lightning-slider-vertical-b5f7875dc9aa833774217760c6ce1264.png";